const CLOUDINARY_MARKER = "res.cloudinary.com";

export const optimizeCloudinaryImage = (
  url,
  {
    width,
    height,
    crop = "fill",
    quality = "auto",
    format = "auto",
    dpr = "auto",
  } = {}
) => {
  if (!url || typeof url !== "string" || !url.includes(CLOUDINARY_MARKER)) {
    return url;
  }

  const uploadToken = "/upload/";
  const uploadIndex = url.indexOf(uploadToken);
  if (uploadIndex === -1) return url;

  const before = url.slice(0, uploadIndex + uploadToken.length);
  const after = url.slice(uploadIndex + uploadToken.length);

  const parts = after.split("/");
  const hasVersion = /^v\d+$/.test(parts[0] || "");
  const version = hasVersion ? `${parts.shift()}/` : "";
  const publicId = parts.join("/");

  const transforms = [`f_${format}`, `q_${quality}`, `dpr_${dpr}`];
  if (width) transforms.push(`w_${Number(width)}`);
  if (height) transforms.push(`h_${Number(height)}`);
  if (width || height) transforms.push(`c_${crop}`);

  return `${before}${transforms.join(",")}/${version}${publicId}`;
};

